import Vue from 'vue'
import App from './App.vue'
import router from './router'
window.configs = {timeStage1: 10000, timeWrite: 40, timeStage2: 5000}
Vue.config.productionTip = false
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
